import { getIsImraUser } from "@/imra/getIsImraUser";
import useUser from "@/users/useUser";

export { getIsImraUser };

const useIsImraUser = (): boolean => {
  const { data: user } = useUser();
  const hasFeature = (name: string) => user?.features?.[name] === "on";
  return getIsImraUser(hasFeature);
};

export default useIsImraUser;
